export const setCategoryParent = (state, param) => {
  state.parents = param.data.data.catalog
}

export const setCategoryChild = (state, param) => {
  state.childs = param.data.data.catalog
}

export const setAvailableQuota = (state, param) => {
  state.availableQuota = param
}

export const setCategory = (state, param) => {
  state.details = param.data.data.catalog
}

export const setCategoryTranslation = (state, param) => {
  state.translations = param.data.data.translations
}

export const setCategoriesSortList = (state, param) => {
  state.categoriesSortList = param.data.data.category_sort_list
  state.editSortingKey = param.data.data.key
}

export const setCategoriesDraggable = (state, param) => {
  state.categoriesSortList = param
}

export const setSortingEditKey = (state, param) => {
  state.editSortingKey = param.data.data.key
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/mutations.js